import * as React from "react";
import type { SVGProps } from "react";
const SvgYoutubeGrey = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 25"
    {...props}
  >
    <g clipPath="url(#youtube-grey_svg__a)">
      <path
        fill="#B5AEAB"
        d="M23.522 6.203A3.02 3.02 0 0 0 21.4 4.068c-1.876-.505-9.376-.505-9.376-.505s-7.5 0-9.377.505A3.02 3.02 0 0 0 .526 6.203C.024 8.088.024 12.018.024 12.018s0 3.93.502 5.814a3.02 3.02 0 0 0 2.121 2.136c1.877.504 9.377.504 9.377.504s7.5 0 9.376-.505a3.02 3.02 0 0 0 2.122-2.135c.502-1.885.502-5.815.502-5.815s0-3.93-.502-5.814"
      />
      <path
        fill="#F6F5F5"
        d="M9.57 15.587V8.449l6.272 3.569z"
      />
    </g>
    <defs>
      <clipPath id="youtube-grey_svg__a">
        <path
          fill="#fff"
          d="M0 .018h24v24H0z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgYoutubeGrey;
